export const ADD_EMPLOYEE = '[WHATIF] add employee';
export const REMOVE_EMPLOYEES = '[WHATIF] remove employee';
export const CLEAR_EMPLOYEES = '[WHATIF] clear employees';
export const SET_EMPLOYEE_VALUE = '[WHATIF] set employee value';
export const SET_OUTPUT_CURRENCY = '[WHATIF] set output currency';
export const GET_CALCULATIONS_SUCCESS = '[WHATIF][GET] get calculations success';
export const SET_LOADING_CALCULATIONS = '[WHATIF][LOADING] set loading calculations';
export const SET_PAGETYPE = '[WHATIF][PAGETYPE] set pagetype';
export const SELECT_RESULT = '[WHATIF][SET] set result';
export const DELETE_SELECTED = '[WHATIF][SET] delete selected results';
export const SET_LOADING_EXCEL_DOWNLOADING = '[WHATIF][LOADING] set loading download excel';
export const SET_DETAIL_INDEX = '[WHATIF][SET] set detail index';
export const GET_COUNTRIES_DICTIONARY_SUCCESS = '[WHATIF][GET] get countries dictionary success';
export const SET_EMPLOYEES_FROM_CSV = '[WHATIF][GET] set employees from csv';
